export { UploadFileReq } from './upload-file-req';
export { DocumentTypeCode } from './upload-file-req';
export { DocumentTypes } from './upload-file-req';
